import React from "react";
import { Box, Grid, InputLabel } from "@mui/material";
import AvatarPanel from "./AvatarPanel.tsx";
import FavouritesQuestionRow from "./FavouriteQuestionRow.tsx";
import { Trans } from "@lingui/react/macro";

interface FavouritesPromptProps {
  children?: React.ReactNode;
  content: Array<any>;
  role: string;
}

const FavouritesPrompt: React.FC<FavouritesPromptProps> = (props) => {
  return (
    <Box marginBottom={"10%"}>
      <Grid
        container
        direction="row"
        spacing={2}
        alignContent="flex-start"
        alignItems="flex-start"
      >
        <Grid size={{ xs: 1, lg: 1 }}>
          <AvatarPanel />
        </Grid>
        <Grid size={{ xs: 11, lg: 11 }}>
          <InputLabel sx={{ marginBottom: "3%", marginTop: "1.5%" }}>
            <Trans
              context={
                "Title of a section which lists the user's favourite questions."
              }
            >
              Here is a list of your favourite questions
            </Trans>
          </InputLabel>
          {props.content.map((item, index) => (
            <Box key={index}>
              <FavouritesQuestionRow
                index={index + 1}
                text={item.text}
                id={item.id}
              />
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FavouritesPrompt;
